import api from "../../services/api";
import { initLoading, endLoading } from "../slices/generics.slice";

export const subscriptionsStripeGetPlans = (
  id,
  priceId,
  country = "US",
  exclusiveFor = "website_stripe",
  all = false,
  partner = null,
  cpn = "",
) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const countryFormatted = country.toUpperCase() === "BR" ? "BRASIL" : "US";

    let params = "";

    if (id !== "" && priceId !== "") {
      params += id !== "" ? `id=${id}` : "";
      params += priceId !== "" ? `&priceId=${priceId}` : "";
      params += `&country=${countryFormatted}`;
      params += partner !== "" ? `&partner=${partner}` : "";
      params += cpn !== "" ? `&cpn=${cpn}` : "";
    } else {
      params += exclusiveFor !== "" ? `exclusiveFor=${exclusiveFor}` : "";
      params += `&country=${countryFormatted}`;
      params += cpn !== "" ? `&cpn=${cpn}` : `&ignoreCpn=${true}`;
    }

    try {
      if (all) {
        const response = await api.get(`/subscriptions-stripe/get-plans?${params}`);
        return response.data.result.items;
      } else {
        const response = await api.get(`/subscriptions-stripe/get-plans?${params}`);
        return response.data.result.items[0];
      }
    } catch (error) {
      console.log("subscriptionsStripeGetPlans", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getUserInformation = () => {
  return async () => {
    const sources = [
      {
        url: "https://ipinfo.io/json",
        parse: async (res) => {
          const data = await res.json();
          return {
            timezone: data.timezone,
            country_code: data.country,
            currency: data.country === "BR" ? "BRL" : "USD",
          };
        },
      },
      {
        url: "https://ipwho.is/",
        parse: async (res) => {
          const data = await res.json();
          return {
            timezone: data.timezone.id,
            country_code: data.country_code,
            currency: data.country_code === "BR" ? "BRL" : "USD",
          };
        },
      },
      {
        url: "https://ipapi.co/json/",
        parse: async (res) => {
          const data = await res.json();
          return { timezone: data.timezone, currency: data.currency, country_code: data.country_code };
        },
      },
    ];

    for (const source of sources) {
      try {
        const response = await fetch(source.url);
        if (response.ok) {
          const responseFormatted = await source.parse(response);
          if (responseFormatted) {
            return responseFormatted;
          } else {
            return { country_code: "US", timezone: "America/Sao_Paulo", currency: "USD" };
          }
        }
      } catch (error) {
        console.log("getUserInformation", error);
      }
    }
  };
};

export const subscriptionsStripe = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`/subscriptions-stripe`, JSON.stringify(body));
      return response.data.result.items[0];
    } catch (error) {
      console.log("subscriptionsStripe", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postUpgradeDdowngrade = (studentPlanId) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const body = { studentPlanId: studentPlanId };

    try {
      const response = await api.post(`/subscriptions-stripe/create-setup-intent-session`, JSON.stringify(body));
      return response.data.result.items[0];
    } catch (error) {
      console.log("subscriptionsStripe", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postChangePlan = (changeType, changeTypeAt, studentPlanId, planId, priceId, cardPay) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const body = {
      changeType: changeType,
      changeTypeAt: changeTypeAt,
      studentPlanId: Number(studentPlanId),
      newPlanId: planId,
      newPlanPriceId: priceId,
      paymentMethod: cardPay, // "current"
      coupon: null,
    };

    try {
      const response = await api.post(`/subscriptions-stripe/change-plan`, JSON.stringify(body));
      return response.data.result.items[0];
    } catch (error) {
      console.log("postChangePlan", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getInfoPartners = (name) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`/partners/get-partners?name=${name}`);
      return response.data.result.items[0];
    } catch (error) {
      console.log("subscriptionsStripe", error);
    } finally {
      dispatch(endLoading());
    }
  };
};
